import { render, staticRenderFns } from "./CallbackPage.vue?vue&type=template&id=428dfd66&scoped=true"
import script from "./CallbackPage.vue?vue&type=script&lang=ts"
export * from "./CallbackPage.vue?vue&type=script&lang=ts"
import style0 from "./CallbackPage.vue?vue&type=style&index=0&id=428dfd66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428dfd66",
  null
  
)

export default component.exports